import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';
import { NotificationModel } from 'src/app/notification/models/notification';
import { NOTIFICATION } from 'src/app/notification/tokens';
import { Address, CompanyClient } from 'src/business/services/client.generated';
import { MediaModule } from 'src/layout/media/media.module';
import { MarketSegment } from 'src/utils/market-segment.util';

@Component({
    selector: 'app-cvr-ean-lookup',
    standalone: true,
    imports: [TranslateModule, MediaModule, CommonModule],
    templateUrl: './cvr-ean-lookup.component.html',
    styleUrl: './cvr-ean-lookup.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CvrEanLookupComponent {
    @Output()
    address: EventEmitter<Address> = new EventEmitter<Address>();
    @Output()
    vat: EventEmitter<string> = new EventEmitter<string>();
    @Input()
    checkoutType: string;
    private _companyClient: CompanyClient;

    constructor(
        @Inject(NOTIFICATION)
        private _notificationService: ReplaySubject<NotificationModel>,
    ) {
        this._companyClient = new CompanyClient(window.location.origin);

    }

    async search() {
        var id = new FormData(window['CVR_GLN_LOOKUP']).get('id') as string;
        if (id == null || id.length < 1)
            return false;
        if (this.checkoutType == 'business') {

            var address = await this._companyClient
                .cvr(id)
                .catch(errorMessage => {
                    this._notificationService.next({
                        title: '',
                        text: errorMessage,
                        position: 'top-mid',
                        color: 'var(--error-color, white)',
                        backgroundColor: 'var(--error-background-color, red)',
                        duration: 2000
                    });
                    return {
                        vatNumber: id,

                    }
                }
                );

            this.address.emit(MarketSegment.mapAddress(address));
            this.vat.emit(address.vatNumber);
        } else {

            var address = await this._companyClient
                .gln(id)
                .catch(errorMessage => {
                    this._notificationService.next({
                        title: '',
                        text: errorMessage,
                        position: 'top-mid',
                        color: 'var(--error-color, white)',
                        backgroundColor: 'var(--error-background-color, red)',
                        duration: 3000
                    });
                    return {
                        vatNumber: id,

                    }
                }
                );

            this.address.emit(MarketSegment.mapAddress(address));
            this.vat.emit(address.vatNumber);
        }
        return false;
    }
}
